import React from 'react';
import { PageToolbar } from '../common';

/**
 * CustomersHeader - Header component for Customers page
 * Contains: page title with count, add button, toolbar with status filter
 */
const CustomersHeader = ({
  viewMode,
  onViewModeChange,
  searchTerm,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  customerCount,
  isAdmin,
  onAddClick
}) => {
  return (
    <div className="page-header">
      <div className="header-top">
        <div className="header-left">
          <h1>Customers</h1>
          <span className="customer-count">{customerCount} customers</span>
        </div>
        <div className="header-buttons">
          {isAdmin && (
            <button className="add-button" onClick={onAddClick}>
              + Add Customer
            </button>
          )}
        </div>
      </div>

      <PageToolbar
        viewMode={viewMode}
        onViewModeChange={onViewModeChange}
        searchTerm={searchTerm}
        searchPlaceholder="Search by name, contact, or city..."
        onSearchChange={onSearchChange}
        showScanButton={false}
      >
        <select
          className="filter-select"
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
        >
          <option value="all">All Status</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </PageToolbar>
    </div>
  );
};

export default CustomersHeader;
